import { FC } from 'react';

import Footer from 'components/primitives/Footer';
import useIsMobile from 'hooks/useIsMobile';
import { PrivacyPolicyViewProps } from './PrivacyPolicy.props';

const PrivacyPolicyView: FC<PrivacyPolicyViewProps> = (props) => {
  const isMobile = useIsMobile();
  return (
    <>
      {/* Fix a11y: add unique title to iframe */}
      <iframe
        title="Privacy Policy"
        style={{
          width: '100vw',
          height: '100vh',
        }}
        src="/privacy-policy.html"></iframe>
      {isMobile ? <></> : <Footer />}
    </>
  );
};

export default PrivacyPolicyView;
